import { useState } from "react";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
export default function SingleProduct(props) {
  const description = props.productdescription;
  return (
    <div className="product-box">
      <div className="bigImage">
        <a
          className="firstImglink"
          href="#"
          data-fancybox="gallery"
          onClick={props.onClickHandler}
        >
          <img
            className="firstBigImg"
            src={`https://spagnoladmin.lavallearredobagno.it${props.bigimage}`}
            alt=""
          />
        </a>
      </div>
      <div className="bottom-part">
        <div className="mediumImg flex-item">
          <a href="#" onClick={props.onClickHandler}>
            <img
              className="firstMidImg"
              src={`https://spagnoladmin.lavallearredobagno.it${props.mediumimage}`}
              alt=""
            />
          </a>
        </div>
        <div className="column flex-item">
          <div className="smallImg">
            <a href="#" onClick={props.onClickHandler}>
              <img
                className="firstSmallImg"
                src={`https://spagnoladmin.lavallearredobagno.it${props.smallimage}`}
                alt=""
              />
            </a>
          </div>

          <div className="text-box">
            <p className="smalltext italian">
              {description && <BlocksRenderer content={description} />}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
